import React from 'react'
import { Snackbar, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
    root: {
        top: theme.spacing(9),
        '& .MuiAlert-root': {
            backgroundColor: '#0047b3',
            color: '#fff'
        },
        '& .MuiAlert-icon': {
            color: '#fff'
        }
    }
}))

export default function NotificationReciboRechazado(props) {

    const { notifyReciboRechazado, setNotifyReciboRechazado } = props;
    const classes = useStyles()

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotifyReciboRechazado({
            ...notifyReciboRechazado,
            isOpen: false
        })
    }

    return (
        <Snackbar
            autoHideDuration={3000}
            className={classes.root}
            open={notifyReciboRechazado.isOpen}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            onClose={handleClose}>
            <Alert
                onClose={handleClose}>
                {notifyReciboRechazado.message}
            </Alert>
        </Snackbar>
    )
}